import { CHILD_PRICE_STEP } from "Components/Features/CheckPrice/Products/LifeProducts/Child";

import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";

export function mapFromCommerceChildHealth(data: {
  [key: string]: any;
}): FormStates {
  const { coverageGroup, relatedChildProductId } = data;

  return {
    [CHILD_PRICE_STEP.id]: {
      childHealthcoverage: coverageGroup,
      buyChildHealthInsurance: true,
      relatedChildProductId,
    },
  };
}
